import { render, staticRenderFns } from "./SvRadio.vue?vue&type=template&id=dd8a9ed4&scoped=true&lang=pug&"
import script from "./SvRadio.vue?vue&type=script&lang=js&"
export * from "./SvRadio.vue?vue&type=script&lang=js&"
import style0 from "./SvRadio.vue?vue&type=style&index=0&id=dd8a9ed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8a9ed4",
  null
  
)

export default component.exports